require('./mainApp.style.scss');
const Subscription = require('../../model/Subscription');
const ResourceGroup = require('../../model/ResourceGroup');
const { permissions } = require('../../constants/permissions');

class MainAppController {
    constructor($scope, $state, $filter, $rootScope, storageService, principalService, sseService, crudService, docsService, logoutService, sharedPersistenceService, utilsService, notificationService, config, iamPersistenceService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.storageService = storageService;
        this.principalService = principalService;
        this.iamPersistenceService = iamPersistenceService;
        this.utilsService = utilsService;
        this.sseService = sseService;
        this.crudService = crudService;
        this.docsService = docsService;
        this.logoutService = logoutService;
        this.notifications = notificationService;
        this.config = config;
        this.currentUserUsername = this.storageService.getUsername();
        this.REST_ENDPOINTS = sharedPersistenceService.getRestEndpoints();
        this.sharedPersistenceService = sharedPersistenceService;
        this.version = this.config.appVersion;

        this.compactNavigation = this.storageService.getCompactNavigation() ? this.storageService.getCompactNavigation() : false;

        this.$rootScope.$on("protection-set-edit", () => {
            this.currentProtectionSet = this.storageService.getProtectionSet();
        });

        this.$rootScope.$on("role-change", () => {
            this.setAdminLinks();
        });

        this.$scope.$watch(() => this.compactNavigation, compactNavigation => {
            this.storageService.setCompactNavigation(compactNavigation);
        });

        $scope.$watch(() => this.principalService.timeLeftBeforeTokenExpire(), timeLeft => {
            if (timeLeft === 120)
                this.showSessionExpirationDialog = true;
        });
    }

    async $onInit() {
        this.initLinks();
        await this.initSubscriptionSelection().then(() => {
            if (this.storageService.getProtectionSet().uuid) {
                this.sharedPersistenceService.getProtectionSets().then(res => {
                    if (res.filter(item => item.uuid === this.storageService.getProtectionSet().uuid).length) {
                        this.currentProtectionSet = this.storageService.getProtectionSet();
                    } else {
                        const defaultProtectionSet = res.find((protectionSet => protectionSet.name === "default"));
                        this.storageService.setProtectionSet(defaultProtectionSet);
                        this.currentProtectionSet = this.storageService.getProtectionSet();
                    }
                });
                this.currentProtectionSet = this.storageService.getProtectionSet();
            } else {
                this.sharedPersistenceService.getProtectionSets().then(res => {
                    this.storageService.setProtectionSet(res[0]);
                    this.currentProtectionSet = res[0];
                });
            }

            this.sseService.addEventListener('sse', this.storageService.getManagerHostname());
            this.setActiveLinkByState(this.$state.current);
        });

        this.$scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams, options) => {
            const appState = this.navLinks.filter(l => l.state === toState.name)[0];
            if (appState) {
                this.activeLink = appState;
            }
        });
    }

    setActiveLinkByState(newState) {
        if (!newState) return;
        let state = this.navLinks.filter(l => l.state === newState.name)[0];
        if (state) this.activeLink = state;
    }

    initSubscriptionSelection() {
        return new Promise(resolve => {
            this.currentSubscription = this.storageService.getSubscription();
            resolve();
        });
    };

    getSubscription() {
        return this.crudService.get(this.REST_ENDPOINTS.SUBSCRIPTIONS_REST, null, null, null, null, true, false, true).then(resp => {
            return resp.data.entities.map(Subscription.fromRaw);
        });
    }

    onProtectionSetChange() {
        this.currentProtectionSet = this.storageService.getProtectionSet();
        if (this.currentSubscription.uuid !== this.storageService.getSubscription().uuid) {
            this.currentSubscription = this.storageService.getSubscription();
            this.iamPersistenceService.getPermissions(this.currentSubscription.managerEndpointUrl, this.currentSubscription.uuid).then((res) => {
                this.storageService.setPermissions(res);
                this.$scope.$broadcast('sub-changed');
            });
        } else {
            this.$scope.$broadcast('sub-changed');
        }
    }

    initLinks() {
        this.navLinks = [
            {
                title: this.$filter('translate')('main.nav.left.dashboard.label'),
                icon: 'icon-dashboard',
                state: 'app.dashboard',
                isVisible: () => true,
                id: 'side-nav-dashboard'
            },
            {
                title: this.$filter('translate')('main.nav.left.vms.label'),
                icon: 'icon-vm',
                state: 'app.virtualmachines',
                isVisible: () => true,
                id: 'side-nav-virtual-machines'
            },
            {
                title: this.$filter('translate')('main.nav.left.policies.label'),
                icon: 'icon-protectiongroups',
                state: 'app.policies',
                isVisible: () => true,
                id: 'side-nav-policies'
            },
            {
                title: this.$filter('translate')('main.nav.left.targets.label'),
                icon: 'icon-targets',
                state: 'app.targets',
                isVisible: () => true,
                id: 'side-nav-targets'
            },
            {
                title: this.$filter('translate')('main.nav.left.tasks.label'),
                icon: 'icon-jobs',
                state: 'app.jobs',
                isVisible: () => true,
                id: 'side-nav-jobs'
            },
            {
                title: this.$filter('translate')('main.nav.left.events.label'),
                icon: 'icon-events',
                state: 'app.events',
                isVisible: () => true,
                id: 'side-nav-events'
            },
            {
                title: this.$filter('translate')('main.nav.left.reports.label'),
                icon: 'icon-reports',
                state: 'app.reports',
                isVisible: () => true,
                id: 'side-nav-reports'
            },

        ];

        this.setAdminLinks();


        this.helpLinks = [
            {
                title: this.$filter('translate')('main.nav.top.help.thisPage.label'),
                action: () => this.docsService.openHelp(),
                state: 'app.dashboard',
                id: 'help-this-page',
                isDisabled: false
            },
            {
                title: this.$filter('translate')('main.nav.top.help.userManual.label'),
                action: () => this.docsService.openHelpWindow(),
                state: 'app.dashboard',
                id: 'help-user-manual',
                isDisabled: false
            },
            {
                title: 'SaaS Subscription Information',
                action: () => {
                    this.showSaasSubscriptionDialog = true;
                },
                state: 'app.dashboard',
                id: 'saasSubscription',
            },
            {
                title: this.$filter('translate')('main.nav.top.help.about.label'), action: () => {
                    this.aboutDialog = true;
                }, state: 'app.dashboard', id: 'help-about',
                isDisabled: false
            },
        ];

        if (this.utilsService.isBackUpAdmin()) {
            this.userLinks = [
                {
                    title: this.$filter('translate')('main.nav.top.user.apiExplorer.addition'),
                    action: () => this.showRestApiExplorerDialog = true,
                    state: 'app.dashboard',
                    id: 'user-api-explorer'
                },
                {
                    title: this.$filter('translate')('main.nav.top.user.logout.label'),
                    action: () => this.logoutService.logout(),
                    state: 'app.dashboard',
                    id: 'user-sing-out'
                },
            ];
        } else {
            this.userLinks = [
                {
                    title: this.$filter('translate')('main.nav.top.user.logout.label'),
                    action: () => this.logoutService.logout(),
                    state: 'app.dashboard',
                    id: 'user-sing-out'
                },
            ];
        }

    }

    setAdminLinks() {
        this.adminLinks = this.principalService.isInAnyRole(['Built-in Administrator', 'Administrator']) ? [
            {
                title: 'Roles',
                action: () => {
                    this.showRolesDialog = true;
                },
                state: 'app.dashboard',
                id: 'user-roles'
            },
            {
                title: 'Service Principals',
                action: () => {
                    this.showServicePrincipalDialog = true;
                },
                state: 'app.dashboard',
                id: 'service-principal',
                // isDisabled: !this.iamPersistenceService.hasPermissions(permissions.SA_LIST)
            },
            {
                title: 'Protection Sets',
                action: () => {
                    this.showProtectionSetDialog = true;
                    this.protectionSetEditMode = true;
                },
                state: 'app.dashboard',
                id: 'manage-protection-sets',
            },
            {
                title: 'HYCU Controller Deployment',
                action: () => {
                    this.showECDeployDialog = true;
                },
                state: 'app.dashboard',
                id: 'ec-deploy',
                noPermissions: !this.iamPersistenceService.hasPermissions(permissions.EC_DEPLOY)
            }
        ] : [];
    }

    changeState(state) {
        this.$state.go(state);
    }
}

MainAppController.$inject = ['$scope', '$state', '$filter', '$rootScope', 'storageService', 'principalService', 'sseService', 'crudService', 'docsService', 'logoutService', 'sharedPersistenceService', 'utilsService', 'notificationService', 'config', 'iamPersistenceService'];

const mainAppComponent = {
    controller: MainAppController,
    template: require('./mainApp.template.html')
};

module.exports = mainAppComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/mainApp.component.js